export const handleUpdateFilter = (key, value, filters, setFilters, setSearchParams) => {
	const newFilters = { ...filters, [key]: value, page: 1 };
	if (key === 'page') {
		newFilters.page = value;
	}
	setFilters(newFilters);
	const sp = new URLSearchParams();
	Object.entries(newFilters).forEach(([k, v]) => {
		if (v && v !== '' && v !== 1) sp.set(k, v);
	});
	setSearchParams(sp);
};